import api from '@/client/core/api'
import {
  InstagramInstantwinPretestEntryCode,
  InstagramInstantwinPretestEntryCodeResponse,
  normalizeInstagramInstantwinPretestEntryCode,
  parseInstagramInstantwinPretestEntryCodeResponse
} from '@/typings/api/instagram_instantwin_pretest_entry_codes.schema'

type GetInstagramInstantwinPretestEntryCodeApiResponse = InstagramInstantwinPretestEntryCodeResponse & {
  error?: {
    type?: string
    message?: string
    status?: number
  }
}

export class GetInstagramInstantwinPretestEntryCodeApiError extends Error {
  constructor(
    public type: string,
    message?: string,
    public status?: number
  ) {
    super(message || type)
  }
}

export async function getInstagramInstantwinPretestEntryCode(
  prizeId: number
): Promise<InstagramInstantwinPretestEntryCode | null> {
  const response = await api.get<GetInstagramInstantwinPretestEntryCodeApiResponse>(
    `/instagram_instantwin_prizes/${prizeId}/pretest_entry_code`
  )

  if (response instanceof Error) {
    throw response
  }

  if (response?.error?.type) {
    throw new GetInstagramInstantwinPretestEntryCodeApiError(
      response.error.type,
      response.error.message,
      response.error.status
    )
  }

  const parsedResponse = parseInstagramInstantwinPretestEntryCodeResponse(response)

  return normalizeInstagramInstantwinPretestEntryCode(parsedResponse.data)
}
